import React from "react";
import { StyledTypographyHeaderItem } from "src/components/Styled/typography";
import pageURL from "src/constants/pageURL";
import classnames from "classnames";
import { NavLink } from "react-router-dom";
import { MobileMenuContainer, NavigationMenu } from "./StyledComponents";

export const mobileMenu = (viewName: any, onItemClick: () => void) => {
  return (
    <MobileMenuContainer>
      <NavigationMenu
        className={classnames(["navigation_menu", "mobile_menu"])}
        $viewName={viewName}
      >
        <StyledTypographyHeaderItem className="mobile_group_title">
          Use Cases
        </StyledTypographyHeaderItem>
        <NavLink onClick={onItemClick} to={pageURL.useCaseGameFi}>
          {() => (
            <StyledTypographyHeaderItem className={"mobile_sub_item"}>
              GameFi & NFT Storage
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink onClick={onItemClick} to={pageURL.useCaseEnterpriseData}>
          {() => (
            <StyledTypographyHeaderItem className={"mobile_sub_item"}>
              Enterprise Data
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink onClick={onItemClick} to={pageURL.useCaseCdnAcceleration}>
          {() => (
            <StyledTypographyHeaderItem className={"mobile_sub_item"}>
              CDN Acceleration
            </StyledTypographyHeaderItem>
          )}
        </NavLink>

        <NavLink onClick={onItemClick} to={pageURL.useCaseVideoSreaming}>
          {() => (
            <StyledTypographyHeaderItem className={"mobile_sub_item"}>
              Video Streaming
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.useCaseDapp}
          className={classnames(["item_with_btm_margin"])}
        >
          {() => (
            <StyledTypographyHeaderItem
              className={classnames([
                "mobile_sub_item",
                "item_with_btm_margin",
              ])}
            >
              Decentralized Applications
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <StyledTypographyHeaderItem className="mobile_group_title">
          Network
        </StyledTypographyHeaderItem>
        <NavLink onClick={onItemClick} to={pageURL.networkDecFoundation}>
          {() => (
            <StyledTypographyHeaderItem className={"mobile_sub_item"}>
              Reliable Network
            </StyledTypographyHeaderItem>
          )}
        </NavLink>

        <NavLink
          onClick={onItemClick}
          to={pageURL.networkDevTools}
          className={classnames(["item_with_btm_margin"])}
        >
          {() => (
            <StyledTypographyHeaderItem className={"mobile_sub_item"}>
              Developer-Friendly Tools
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.ecosystem}
          className={classnames(["item_with_btm_margin1"])}
        >
          {({ isActive }) => (
            <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
              Ecosystem
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.wallet}
          className={classnames(["item_with_btm_margin1"])}
        >
          {({ isActive }) => (
            <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
              Wallet
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.communityCollaborate}
          className={classnames(["item_with_btm_margin1"])}
        >
          {({ isActive }) => (
            <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
              Community
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.resourcesGuide}
          className={classnames(["item_with_btm_margin1"])}
        >
          {({ isActive }) => (
            <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
              Resources
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.home}
          className={classnames(["item_with_btm_margin1"])}
        >
          {({ isActive }) => (
            <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
              Blog
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
        <NavLink
          onClick={onItemClick}
          to={pageURL.contactUs}
          className={classnames(["item_with_btm_margin1"])}
        >
          {({ isActive }) => (
            <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
              Contact Us
            </StyledTypographyHeaderItem>
          )}
        </NavLink>
      </NavigationMenu>
    </MobileMenuContainer>
  );
};
